import React from 'react';
import AdSidebar from './AdSidebar';

/**
 * Wrapper component that adds left and right sidebar ads to page content
 * Coordinates between left and right to ensure different ads are shown
 */
const ContentWithAds = ({ children }) => {
    const [leftAdId, setLeftAdId] = React.useState(null);
    const [rightAdId, setRightAdId] = React.useState(null);

    return (
        <div className="flex gap-4 max-w-[1920px] mx-auto px-4">
            {/* Left Sidebar - Compact */}
            {/* Left Sidebar - Removed for cleaner layout */}
            {/* <div className="hidden xl:block w-48 flex-shrink-0" /> Optional: Keep empty space if needed, otherwise remove completely */}

            {/* Main Content - Centered */}
            <div className="flex-1 min-w-0">
                {children}
            </div>

            {/* Right Sidebar - Compact */}
            <AdSidebar
                position="right"
                currentAdId={rightAdId}
                setCurrentAdId={setRightAdId}
                otherSidebarAdId={leftAdId}
            />
        </div>
    );
};

export default ContentWithAds;
